export class ToolReturnToolsFilterModel {
    public hasMaintenanceAtLine;
    public excludedFromMaintenance;


    constructor(toolReturnToolsFilterModel: any = {}) {
        this.excludedFromMaintenance = toolReturnToolsFilterModel.excludedFromMaintenance || false;
        this.hasMaintenanceAtLine = toolReturnToolsFilterModel.hasMaintenanceAtLine || false;
    }
}
